export default __webpack_public_path__ + "static/media/Badge9.59daf23f.png";